/* eslint-disable react-hooks/exhaustive-deps */
import { useAmplitude } from "lib/amplitude/Amplitude";
import stripUndefined from "lib/utils/stripUndefined";
import { Router, useRouter } from "next/router";
import type { ReactElement } from "react";
import { memo, useCallback, useEffect } from "react";

interface IAmplitudeTrackPageViewsProps {
  children?: ReactElement;
}

function AmplitudeTrackPageViews({ children }: IAmplitudeTrackPageViewsProps) {
  const amplitude = useAmplitude();
  const router = useRouter();

  const routeChangeComplete = useCallback(() => {
    const eventProperties = stripUndefined({
      route: router.route || null,
      pathname: router.pathname || null,
      search: router.asPath.replace(router.pathname, "") || null,
      referrer: typeof document !== "undefined" ? document.referrer : null,
    });

    const isEmptyEvent = Object.keys(eventProperties).every((key) => {
      return eventProperties[key] === null;
    });

    if (!isEmptyEvent) {
      amplitude.logEvent("Viewed page", eventProperties);
    }
  }, [router.route, router.pathname, router.asPath]);

  useEffect(() => {
    Router.events.on("routeChangeComplete", routeChangeComplete);
    return () => router.events.off("routeChangeComplete", routeChangeComplete);
  }, [routeChangeComplete, router.events]);

  return children || null;
}

export default memo(AmplitudeTrackPageViews);
